import { BusEvent } from '@web/common';

export class WarehouseRestockChangedBusEvent extends BusEvent {}
